<template lang="html">
    <div>
        <!-- Groups names -->

        <div class="d-flex justify-content-between my-3 bold">
            <div class="flex-grow-1">{{groupNamesString}}</div>
            <div class="fs-small color-1 pointer normal" @click="toggleExpandInfo">{{expanded? 'hide details':'view details'}}</div>
        </div>

        <div v-if="expanded">

            <!-- General Product Changes -->
            <div v-if="productDetailsHasChanges" class="fs-small bg-lighter p-2">
                <div v-for="editedField in product.changes.details">
                    <span v-html="editedField.niceName + ' changed from <b>'+ editedField.oldNiceValue+ '</b> to <b>'+ editedField.newNiceValue +' </b>'"></span>
                </div>
            </div>

            <!-- Product Sales Channels -->
            <div v-if="productSalesChannelsHasChanges" class="fs-small bg-lighter p-2">
                <div v-for="editedField in product.changes.salesChannels">
                    <span v-html="editedField.niceName + ' changed from <b>'+ editedField.oldNiceValue+ '</b> to <b>'+ editedField.newNiceValue +' </b>'"></span>
                </div>
            </div>

            <!-- Added groups -->
            <div v-if="productHasAddedGroups" class="fs-small bg-lighter p-2">
                <div v-for="editedField in product.changes.addedGroups">
                    <div class="bold">Created group: "{{editedField.newNiceValue}}"</div>
                </div>
            </div>

            <!-- Removed groups -->
            <div v-if="productHasRemovedGroups" class="fs-small bg-lighter p-2">
                <div v-for="editedField in product.changes.removedGroups">
                    <div class="bold">Removed group: "{{editedField.oldNiceValue}}"</div>
                </div>
            </div>

            <div v-if="product.groups.length > 0 && groupHasChanges(group)" v-for="group in product.groups" class="fs-small bg-lighter p-2">

                <!-- Group has id -->
                <div v-if="group.id" >
                    <div class="bold">{{group.label}}:</div>

                    <!-- Changes -->
                    <div class="ml-3">

                        <!-- General  -->
                        <div v-if="groupAreaHasChanges(group)">
                            <div class="bold">Group:</div>
                            <div v-for="editedField in group.editedFields" v-if="editedField.name != 'dateFrom' && editedField.name != 'dateTo'">
                                <span v-html="editedField.niceName + ' changed from <b>'+ editedField.oldNiceValue+ '</b> to <b>'+ editedField.newNiceValue +' </b>'"></span>
                            </div>
                        </div>

                        <!-- Schedule  -->
                        <div v-if="schedulesAreaHasChanges(group)">
                            <div class="bold">Schedule:</div>
                            <div v-for="editedField in group.editedFieldsSchedules">
                                <div v-for="changes in editedField.changes" v-if="changes.name != 'repeatsAtWeekDays'">
                                    <span v-html="changes.niceName + ' changed from <b>'+ changes.oldNiceValue+ '</b> to <b>'+ changes.newNiceValue +' </b>'"></span>
                                </div>
                            </div>

                            <!-- Removed schedules: -->
                            <div v-if="group.editedFieldsSchedulesRemoved" v-for="removedSchedule in group.editedFieldsSchedulesRemoved">
                                <span v-html="'Removed schedule that started at: <b>'+removedSchedule.niceName+'</b>'"></span>
                            </div>

                            <!-- Added schedules: -->
                            <div v-if="group.editedFieldsSchedulesAdded" v-for="addedSchedule in group.editedFieldsSchedulesAdded">
                                <span v-html="'Added new schedule that starts at: <b>'+addedSchedule.niceName+'</b>'"></span>
                            </div>

                        </div>

                        <!-- genderPrices  -->
                        <div v-if="genderpricesAreaHasChanges(group)">
                            <div class="bold">Prices:</div>
                            <div v-for="editedField in group.editedFieldsGenderPrice">
                                <div v-for="changes in editedField.changes">
                                    <span v-html="changes.niceName + ' changed from <b>'+ changes.oldNiceValue+ '</b> to <b>'+ changes.newNiceValue +' </b>'"></span>
                                </div>
                            </div>

                            <!-- Removed gender prices: -->
                            <div v-if="group.editedFieldsGenderPriceRemoved" v-for="removedGenderPrice in group.editedFieldsGenderPriceRemoved">
                                <span v-html="'Removed price audience: <b>'+removedGenderPrice.niceName+'</b>'"></span>
                            </div>

                            <!-- Added gender prices: -->
                            <div v-if="group.editedFieldsGenderPriceAdded" v-for="addedGenderPrice in group.editedFieldsGenderPriceAdded">
                                <span v-html="'Added new price audience: <b>'+addedGenderPrice.niceName+'</b>'"></span>
                            </div>

                        </div>

                        <!-- resources  -->
                        <div v-if="resourcesAreaHasChanges(group)">
                            <div class="bold">Resources:</div>
                            <div v-for="editedField in group.editedFieldsResources">
                                <div v-for="changes in editedField.changes">
                                    <span v-html="changes.niceName + ' changed from <b>'+ changes.oldNiceValue+ '</b> to <b>'+ changes.newNiceValue +' </b>'"></span>
                                </div>
                            </div>

                            <!-- Removed schedules: -->
                            <div v-if="group.editedFieldsResourcesRemoved" v-for="removedResource in group.editedFieldsResourcesRemoved">
                                <span v-html="'Removed resource: <b>'+removedResource.niceName+'</b>'"></span>
                            </div>

                            <!-- Added schedules: -->
                            <div v-if="group.editedFieldsResourcesAdded" v-for="addedResource in group.editedFieldsResourcesAdded">
                                <span v-html="'Added new resource: <b>'+addedResource.niceName+'</b>'"></span>
                            </div>

                        </div>

                    </div>

                </div>

            </div>


        </div>

    </div>
</template>

<script>
export default {
    props:{
        product: {
            type: Object,
            required: true
        },
    },
    data: function () {
        return {
            expanded: false
        }
    },
    computed:{
        productDetailsHasChanges: function () {
            return this.product.changes && this.product.changes.details && this.product.changes.details.length > 0
        },
        productHasAddedGroups: function () {
            return this.product.changes && this.product.changes.addedGroups && this.product.changes.addedGroups.length > 0
        },
        productHasRemovedGroups: function () {
            return this.product.changes && this.product.changes.removedGroups && this.product.changes.removedGroups.length > 0
        },
        productSalesChannelsHasChanges: function () {
            return this.product.changes && this.product.changes.salesChannels && this.product.changes.salesChannels.length > 0
        },
        groupsWithChanges: function () {
            return this.product.groups.filter(group => {return this.groupHasChanges(group)})
        },
        groupNamesString: function () {
            let output = [];

            // Add "Details" if there is a change there
            if(this.productDetailsHasChanges){
                output.push('Details')
            }

            // Add "Sales Channels" if there is a change there
            if(this.productSalesChannelsHasChanges){
                output.push('Sales Channels')
            }

            // Add "Groups" if there any added or removed groups
            if(this.productHasRemovedGroups){
                output.push('Group removed')
            }

            let groupChanges = this.groupsWithChanges.map(g => {return g.label})
            if(groupChanges.length > 0){
                output.push(groupChanges)
            }

            return output.join(', ')
        }
    },
    methods: {
        toggleExpandInfo: function () {
            this.expanded = !this.expanded
        },
        groupAreaHasChanges: function (group) {
            if(!group.editedFields || group.editedFields == null){
                return false
            }

            let editedFieldsArray = group.editedFields.filter(field => {
                return field.name != 'dateFrom' && field.name != 'dateTo';
            })

            return editedFieldsArray && editedFieldsArray.length > 0? true : false
        },
        genderpricesAreaHasChanges: function (group) {
            if(group.editedFieldsGenderPriceAdded && group.editedFieldsGenderPriceAdded.length > 0 || group.editedFieldsGenderPriceRemoved && group.editedFieldsGenderPriceRemoved.length > 0){
                return true
            }
            return group.editedFieldsGenderPrice && group.editedFieldsGenderPrice.filter(editedField => {return editedField.changes.length}).length > 0? true : false
        },
        resourcesAreaHasChanges: function (group) {
            if(group.editedFieldsResourcesAdded && group.editedFieldsResourcesAdded.length > 0 || group.editedFieldsResourcesRemoved && group.editedFieldsResourcesRemoved.length > 0){
                return true
            }
            return group.editedFieldsResources && group.editedFieldsResources.filter(editedField => {return editedField.changes.length}).length > 0? true : false
        },
        schedulesAreaHasChanges: function (group) {
            if(group.editedFieldsSchedulesAdded && group.editedFieldsSchedulesAdded.length > 0 || group.editedFieldsSchedulesRemoved && group.editedFieldsSchedulesRemoved.length > 0){
                return true
            }

            if(!group.editedFieldsSchedules || group.editedFieldsSchedules == null){
                return false
            }

            return group.editedFieldsSchedules && group.editedFieldsSchedules.filter(editedField => {return editedField.changes.length}).length > 0? true : false
        },
        groupHasChanges: function (group) {
            if(group.id == null){
                return false
            }
            
            return (
                this.groupAreaHasChanges(group) == true ||
                this.genderpricesAreaHasChanges(group) == true ||
                this.resourcesAreaHasChanges(group) == true ||
                this.schedulesAreaHasChanges(group) == true
            )
        }

    }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// scheduleGroupChanges.vue?c84d12c4